import { Entry } from "types/entry";

export const getEntryLikes = (entry: Entry) => {
  if (!entry.likesIds) return 0;
  return Object.values(entry.likesIds).filter((like) => like).length
}